export function loadGoogleMapsApi(apiKey: string): () => Promise<void> {
  return () => {
    if (typeof (window as any).google !== 'undefined' && (window as any).google.maps) {
      return Promise.resolve();
    }

    const existing = document.querySelector<HTMLScriptElement>(
      'script[data-google-maps]'
    );
    if (existing) {
      if (typeof (window as any).google !== 'undefined' && (window as any).google.maps) {
        return Promise.resolve();
      }
      return new Promise<void>((resolve) => {
        existing.addEventListener('load', () => resolve());
        existing.addEventListener('error', () => resolve());
        setTimeout(resolve, 4000);
      });
    }

    return new Promise<void>((resolve) => {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.setAttribute('data-google-maps', 'true');
      script.onload = () => resolve();
      script.onerror = () => resolve();
      setTimeout(resolve, 4000);
      document.head.appendChild(script);
    });
  };
}
